/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FormattedMessage } from 'react-intl-next';
import { isMessagesKey } from '../../util/type-helpers';
import { messages } from '../i18n';
import { emojiCategoryTitle } from './styles';

const EmojiPickerCategoryHeading = ({
  id,
  title,
  className
}) => jsx("div", {
  id: id,
  "data-category-id": id,
  className: className
}, jsx("div", {
  css: emojiCategoryTitle
}, isMessagesKey(title) ? jsx(FormattedMessage, messages[title]) : title));

export default EmojiPickerCategoryHeading;